import script from "./UserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=2b0e7633&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0e7633"]])

export default __exports__